/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Project_Private_Chats_Disabled_Desc_UnnamedInputs */



/**
* | output |
* | --- |
* | "Private chats were turned off for this project: every member sees everyone's chats again." |
*
* @param {Audit_Details_Project_Private_Chats_Disabled_Desc_UnnamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_project_private_chats_disabled_desc_unnamed = /** @type {((inputs?: Audit_Details_Project_Private_Chats_Disabled_Desc_UnnamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Project_Private_Chats_Disabled_Desc_UnnamedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Private Chats wurden für dieses Projekt deaktiviert: Alle Mitglieder sehen wieder die Chats aller Mitglieder.")
	return /** @type {LocalizedString} */ ("Private chats were turned off for this project: every member sees everyone's chats again.")
});